import { Checkbox } from 'src/components/ui/checkbox';
import { clsx } from 'clsx';
import type { TreeNode } from 'src/utils/fileUtils';
import type { ItemCheckHandler } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseTableList/knowledgeBaseItemHandlers';

export const CheckboxKnowledgeBasePage = ({
  item,
  checked,
  onChange = () => {},
  disabled = false,
  className = '',
}: {
  item?: TreeNode;
  checked?: boolean;
  onChange?: ItemCheckHandler;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <Checkbox
      className={clsx('w-5 h-5', disabled && 'border-grey', className)}
      onDoubleClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      checked={checked}
      onCheckedChange={(checked) => {
        onChange(checked === true, item);
      }}
      disabled={disabled}
    />
  );
};
